import React, { useEffect, useState } from 'react'
import Layout from '../components/Layouts/Layout'
import { Container, Row, Col, NavLink } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Link, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
// import DynamicDropDownComp from '../components/DynamicDropDownComp';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL, ASSET_URL, CONTACT_US_CAMPAIGN_ID, VISAKA_SERVICES_API_URL } from '../config/config';
import CleanNumericInput from '../components/CleanNumericInput';
const Contactus = () => {
    const [loading, setLoading] = useState(false);
    // const { cId, cSource } = useParams();
    const navigate = useNavigate();
    // const [selectedState, setSelectedState] = useState('');
    const [searchParams] = useSearchParams();
    const cId = searchParams.get('c_id') || null;
    const source = searchParams.get('src') || null;

    const campaignId = cId && cId.trim() !== "" ? cId : CONTACT_US_CAMPAIGN_ID;
    const campaignSource = source && source.trim() !== "" ? source : 'website';

     // START GEO SERVICES HOOKS
     const [stateList, setStateList] = useState([]);
     const [districtList, setDistrictList] = useState([]);
     const [allDistricts, setAllDistricts] = useState([]);
     const [zoneList, setZoneList] = useState([]);
     // END GEO SERVICES HOOKS

    // START GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS
    const fetchStateDistrictInfo = async () => {
        const response = await fetch(VISAKA_SERVICES_API_URL + "api/v2/geoservice/district/IN");
        const data = await response.json();
    
        setStateList(data.state);
        setAllDistricts(data.district);
        setZoneList(data.zones); // <== make sure you set this
    };
    useEffect(() => {
        fetchStateDistrictInfo();
    }, []);

    const handleStateDistrict = (e) => {
        const selectedStateName = e.target.value;
        formik.setFieldValue('state', selectedStateName);
    
        // Find the selected state using state_name
        const selectedStateObj = stateList.find(
            (state) => state.state_name === selectedStateName
        );
    
        if (selectedStateObj) {
            // Get zonal_name using zonal_code
            const zoneObj = zoneList.find(
                (zone) => zone.zonal_code === selectedStateObj.zonal_code
            );
    
            if (zoneObj) {
                formik.setFieldValue('zonal_name', zoneObj.zonal_name);
            } else {
                formik.setFieldValue('zonal_name', '');
            }
    
            // Filter districts by state_code
            const filteredDistricts = allDistricts.filter(
                (dist) => dist.state_code === selectedStateObj.state_code
            );
            setDistrictList(filteredDistricts);
        } else {
            // Clear if not found
            setDistrictList([]);
            formik.setFieldValue('zone', '');
        }
    };
    // END GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS

    // FORMIK FORM SUBMIT START
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone: '', 
            state: '', 
            district: '',
            city: '', 
            message: '',
            campaign_id: '',
            source: '',
            zonal_name : '', 
        },

        validate: (values) => {
            let errors = {};
            if (!values.name) { errors.name = 'Name is required'; }
            if (!values.email) { errors.email = 'Email is required'; }
            if (!values.phone) { errors.phone = 'Mobile number is required'; } else if (!/^\d{10}$/.test(values.phone)) { errors.phone = 'Only 10 digit numbers are allowed'; }
            if (!values.state) { errors.state = 'State is required'; }
            if (!values.district) { errors.district = 'District is required'; }
            if (!values.city) { errors.city = 'City is required'; }
            if (!values.message) { errors.message = 'Message is required'; }
            return errors;
        },

        onSubmit: (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("phone_number", values.phone);
            formData.append("state", values.state);
            formData.append("district", values.district);
            formData.append("city", values.city);
            formData.append("description", values.message);
            formData.append("category", "Item enquiry");
            // formData.append("campaign_id", values.campaign_id);
            formData.append("campaign_id", campaignId);
            formData.append("source", campaignSource);
            formData.append("zonal_name", values.zonal_name)

            axios.post(API_URL + `atumobile/enquiries/create`, formData)
                .then(response => {
                    const status = response.data.status;
                    const message = response.data.message || (status === 200 ? 'Our team will connect with you.' : 'Something went wrong, please try again later.');

                    if (status === 200) {
                        navigate('/contactus/success', { state: { message } });
                    } else {
                        navigate('/contactus/error', { state: { message } });
                    }
                    formik.resetForm();
                })
                .catch(err => {
                    // console.log(err);
                    console.error("API Error:", err);
                    if (err.response) {
                        console.error("Response data:", err.response.data);
                        console.error("Status:", err.response.status);
                        console.error("Headers:", err.response.headers);
                    } else if (err.request) {
                        console.error("No response received:", err.request);
                    } else {
                        console.error("Request setup error:", err.message);
                    }

                    navigate('/contactus/error', { state: { message: 'Something went wrong, please try again later.' } });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    })
    // FORMIK FORM SUBMIT END

    return (
        <>
            <Layout>
                <section className='contact-header-bg header-bg' style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${ASSET_URL}assets/images/sliders/contact.webp)`}}>
                    <Container>
                        <Row>
                            <Col sm={12} lg={5}>
                                <div className="title">
                                    <h1 className="title-heading">Contact <span>Us</span></h1>
                                    <p className="title-desc">Let's talk green charging</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="contact-us bg-grey">
                    <Container>
                        <Row className="contact-card">
                            <Col sm={12} md={6} lg={6} className="left-box">
                                <div className="left-box-card222">
                                    <div className="contact-body">
                                        <h5 className="card-heading">Address Details</h5>
                                        <p className="card-desc">We provide fast and knowledgeable service</p>
                                        <div className="row address-features">
                                            <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18px" fill="#ed1c24"><path className="fa-primary" d="M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"></path><path className="fa-secondary" d="M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break"><span><NavLink href="tel:9555333308" className="address-feature-tag fw-semibold text-break">+91-7995888251</NavLink></span></div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18px" fill="#ed1c24"><path className="fa-primary" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48z"></path><path className="fa-secondary" style={{ opacity: '0.4' }} d="M0 112V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V112c0 15.1-7.1 29.3-19.2 38.4L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break"><span><NavLink href="mailto:info@atumcharge.com" className="address-feature-tag fw-semibold text-break">info@atumcharge.com</NavLink></span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row address-features mt-1">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15px" fill="#ed1c24"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break">Visaka Towers, 1-8-303/69/3, Sardar Patel Rd, Begumpet, Secunderabad Hyderabad, Telangana, India 500003</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row socialMedia-features mt-3 gy-4 gy-md-0 gy-lg-0">
                                            <div className="col-12 col-md-4 col-lg-4">
                                                <Link to="https://www.facebook.com/Atumcharge" target="_blank" className='text-decoration-none'>
                                                    <div className="socialMedia-feature1 mx-auto position-relative rounded-1 d-flex justify-content-center">
                                                        <div className="socialMedia-leftbox"></div>
                                                        <div className="socialMedia-feature-icon1 mx-auto d-flex align-items-center justify-content-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="15px" fill="#fff"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>
                                                        </div>
                                                        <div className="socialMedia-feature-tag fw-semibold text-decoration-none">FACEBOOK</div>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-4">
                                                <Link to="https://twitter.com/atumcharge" target="_blank" className='text-decoration-none'>
                                                    <div className="socialMedia-feature2 mx-auto position-relative rounded-1 d-flex justify-content-center">
                                                        <div className="socialMedia-leftbox"></div>
                                                        <div className="socialMedia-feature-icon2 mx-auto d-flex align-items-center justify-content-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15px" fill="#fff"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.15-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
                                                        </div>
                                                        <div className="socialMedia-feature-tag fw-semibold text-decoration-none">TWITTER</div>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-4">
                                                <Link to="https://www.instagram.com/atumcharge/" target="_blank" className='text-decoration-none'>
                                                    <div className="socialMedia-feature3 mx-auto position-relative rounded-1 d-flex justify-content-center">
                                                        <div className="socialMedia-leftbox"></div>
                                                        <div className="socialMedia-feature-icon3 mx-auto d-flex align-items-center justify-content-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15px" fill="#fff"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
                                                        </div>
                                                        <div className="socialMedia-feature-tag fw-semibold text-decoration-none">INSTAGRAM</div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <Col sm={12} md={6} lg={6} className='m-0 p-0'>
                                <div className="right-box-card22 px-0 py-2 px-lg-2 py-lg-2">
                                    <div className="contact-body right-box px-2 py-4 px-sm-2 py-sm-4 px-lg-5 py-lg-5">
                                        <h5 className="card-heading">get in touch</h5>
                                        <p className="card-desc">We take great pride in everything that we do, control over products allows us to ensure our customers receive the best quality service.</p>
                                        <Form onSubmit={formik.handleSubmit} className="contact-form m-0 p-0">
                                            <input type='hidden' name='zonal_name' value={formik.values.zonal_name} />
                                            {/* <Form.Control type="hidden" name="campaign_source" value="website"/>
                                            <Form.Control type="hidden" name="campaign_id" value="300"/> */}
                                            <Row>
                                                <Col sm={12} md={6} lg={6}>
                                                    <Form.Control type="text" name="name" placeholder="Name*" onChange={formik.handleChange} value={formik.values.name} />
                                                    {formik.errors.name ? <span className="text-danger">{formik.errors.name}</span> : null}
                                                </Col>
                                                <Col sm={12} md={6} lg={6}>
                                                    <Form.Control type="text" name="email" placeholder="Email*" onChange={formik.handleChange} value={formik.values.email} />
                                                    {formik.errors.email ? <span className="text-danger">{formik.errors.email}</span> : null}
                                                </Col>
                                                <Col sm={12} md={6} lg={6}>
                                                    {/* <Form.Control type="text" name="phone" placeholder="Phone*" maxLength="10" data-parsley-type="number" onChange={formik.handleChange} value={formik.values.phone} /> */}
                                                    <Form.Control type="text" name="phone" placeholder="Phone*" maxLength={10} value={formik.values.phone}
                                                        onChange={(e) => {
                                                            const cleaned = CleanNumericInput(e.target.value);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                        onPaste={(e) => {
                                                            e.preventDefault();
                                                            const pasted = e.clipboardData.getData('Text');
                                                            const cleaned = CleanNumericInput(pasted);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                        onBlur={(e) => {
                                                            const cleaned = CleanNumericInput(e.target.value);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                    />
                                                    {formik.errors.phone ? <span className="text-danger">{formik.errors.phone}</span> : null}
                                                </Col>

                                                {/* <Col sm={12} md={6} lg={6} className='atc_select'>
                                                    <DynamicDropDownComp apiURL= { 'https://d2tm70q7nw2sv.cloudfront.net/assets/locations/json/indianStatesCities.json'} inputName='state' formik={formik} formikName={'state'} labelName={''} optionsProcessing={(responseData) => { return Array.from(new Set(responseData.map(obj => obj.State))).map((State, index) => { if (index === 0) { return ([<option value='' key={`default_${index}`}>Choose State</option>, <option value={State} key={index}>{State}</option>]) } else { return (<option value={State} key={index}>{State}</option>) } }) }} customOnChangeEvents={(e) => { setSelectedState(e.target.value); }} />
                                                </Col>
                                                <Col sm={12} md={6} lg={6} className='atc_select'>
                                                    <DynamicDropDownComp key={`district_${selectedState.replaceAll(' ', '_')}`} apiURL= { 'https://d2tm70q7nw2sv.cloudfront.net/assets/locations/json/indianStatesCities.json' } inputName='district' formik={formik} formikName={'district'} labelName={''} optionsProcessing={(responseData) => { let distData = responseData.filter((distitem) => distitem.State === selectedState); return distData.map((distObj, index) => { if (index === 0) { return ([<option value='' key={`default_${index}`}>Choose District</option>, <option value={distObj.District} key={index}>{distObj.District}</option>]) } else { return (<option value={distObj.District} key={index}>{distObj.District}</option>) } }) }} customOnChangeEvents={(e) => { }} />
                                                </Col> */}

                                                <Col sm={12} md={6} lg={6} className='atc_select'>
                                                    <select className="form-select" name="state" onChange={handleStateDistrict} value={formik.values.state}>
                                                        <option value="">Select State*</option>
                                                        {stateList.map((state) => (
                                                            <option value={state.state_name} key={state.id}>
                                                                {state.state_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {formik.errors.state && <span className='text-danger mt-1 d-block'>{formik.errors.state}</span>}
                                                </Col>
                                                <Col sm={12} md={6} lg={6} className='atc_select'>
                                                    <select className="form-select" name="district" onChange={formik.handleChange} value={formik.values.district}>
                                                        <option value="">Select District*</option>
                                                        {districtList.map((dist) => (
                                                            <option value={dist.district_name} key={dist.id}>
                                                                {dist.district_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {formik.errors.district && <span className='text-danger mt-1 d-block'>{formik.errors.district}</span>}
                                                </Col>


                                                <Col sm={12} md={6} lg={6}>
                                                    <Form.Control type="text" name="city" placeholder="City*" onChange={formik.handleChange} value={formik.values.city} />
                                                    {formik.errors.city ? <span className="text-danger">{formik.errors.city}</span> : null}
                                                </Col>
                                                <Col sm={12} md={12} lg={12}>
                                                    <Form.Control as="textarea" rows={3} placeholder="Additional Information" name="message" style={{ height: '100px' }} onChange={formik.handleChange} value={formik.values.message} />
                                                    {formik.errors.message ? <span className="text-danger">{formik.errors.message}</span> : null}
                                                </Col>
                                                <Col sm={12} md={6} lg={6}>
                                                    <Button type="submit" className="btn btn-primary" id="contactFormSubmitBtn" disabled={loading}> 
                                                        {loading ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                Submitting...
                                                            </>
                                                        ) : "Submit"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        </>
    )
}

export default Contactus